import React from 'react';
import PropTypes from 'prop-types';

const LinkTextField = ({ source, record, target, basePath, destinationPath }) => 
<span>
    <a target={target} href={basePath +'/' + record.id + '/' + destinationPath}>
        {record[source]}
        {
            //TODO:
            //a good goal would be to make a full path option
            
            //Usage:
            //takes an input origin and a destination and uses record.id to direct to the correct page
            //this code is based on the ShowButton which works similarily - linkToRecord(basePath, record && record.id)}/show
            //https://github.com/marmelab/react-admin/blob/master/packages/ra-ui-materialui/src/button/ShowButton.tsx
        }
        </a>
</span>;

LinkTextField.propTypes = {
    basePath: PropTypes.string,
    destinationPath: PropTypes.string,
    target: PropTypes.string.isRequired,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default LinkTextField;